import { motion } from "framer-motion";
import { ShieldCheck, Check } from "lucide-react";

const reveal = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
};

const Tabela = ({ secao, a }) => (
  <div className="overflow-hidden rounded-2xl border border-maternnia-nevoa/60 bg-white shadow-sm">
    <div className="overflow-x-auto">
      <table className="w-full text-left" data-testid="guia-tabela">
        <thead>
          <tr className={`${a.bg}`}>
            {secao.colunas.map((c) => (
              <th key={c} className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-white">{c}</th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-maternnia-nevoa/50">
          {secao.linhas.map((row, ri) => (
            <tr key={ri} className={ri % 2 ? "bg-maternnia-porcelana/40" : "bg-white"}>
              {row.map((cell, ci) => (
                <td key={ci} className={`px-4 py-3 align-top text-sm leading-relaxed ${ci === 0 ? "font-medium text-maternnia-charcoal" : "text-maternnia-taupe font-light"}`}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const Lista = ({ secao, a }) => (
  <ul className="space-y-3" data-testid="guia-lista">
    {secao.itens.map((it, i) => (
      <li key={i} className="flex gap-3 items-start">
        <span className={`mt-0.5 h-6 w-6 rounded-lg ${a.soft} ${a.softText} flex items-center justify-center shrink-0`}>
          <Check size={13} />
        </span>
        <span className="text-sm text-maternnia-charcoal/90 leading-relaxed font-light">{it}</span>
      </li>
    ))}
  </ul>
);

const GuiaSaude = ({ guia, a }) => {
  if (!guia || !guia.secoes?.length) return null;
  return (
    <section data-testid="etapa-guia-saude" className="py-20 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div {...reveal}>
          <div className="flex items-center gap-2 mb-4">
            <ShieldCheck size={20} className={a.text} />
            <span className={`text-sm font-semibold tracking-widest uppercase ${a.text}`}>Guia oficial de saúde</span>
          </div>
          <h2 className="font-serif text-3xl md:text-4xl text-maternnia-charcoal font-medium">{guia.titulo}</h2>
          <p className="mt-4 text-base text-maternnia-taupe font-light leading-relaxed max-w-2xl">{guia.intro}</p>
        </motion.div>

        <div className="mt-12 space-y-12">
          {guia.secoes.map((secao, i) => (
            <motion.div key={i} {...reveal} transition={{ ...reveal.transition, delay: 0.05 }}>
              <h3 className="font-serif text-xl md:text-2xl text-maternnia-charcoal font-medium mb-5">{secao.titulo}</h3>
              {secao.tipo === "tabela" ? <Tabela secao={secao} a={a} /> : <Lista secao={secao} a={a} />}
              {secao.nota && (
                <p className="mt-3 text-xs text-maternnia-taupe/90 font-light italic leading-relaxed">{secao.nota}</p>
              )}
            </motion.div>
          ))}
        </div>

        <p className="mt-10 text-xs text-maternnia-taupe/80 font-light border-t border-maternnia-nevoa/60 pt-5">
          {guia.fonte} Este material tem caráter educativo e não substitui a avaliação de profissionais de saúde.
        </p>
      </div>
    </section>
  );
};

export default GuiaSaude;
